import { apolloClient } from "@/apollo.services";
import ACCOUNTING_TABLE from "@/graphql/dashboardAccounting/AccountingTable.gql";
import { ApolloClient } from "@apollo/client";
import { Company } from "../../../../types/types/indexTypes";
import moment from "moment-timezone";
import { DashBoardTableStream } from "@/services/dashboardTableStream";
import GET_AMOUNT_IN_GENERAL_DICO from "@/graphql/dashboardAccounting/GetAmountInGeneralDico.gql";
import OPERATING_ACCOUNT_QUERY from "@/graphql/tag/OperatingAccounts.gql";
import { OperatingAccountDataInterface } from "./models";

export default class DesignerDataService {
    apolloClient: ApolloClient<unknown>;
    company: Company;

    constructor(company: Company) {
        this.apolloClient = apolloClient;
        this.company = company;
    }

    async fetchTablesData(
        { className, budgetId, periods, tags, operatingAccountId, accountingPeriodId },
        returnDashboardTable = false,
    ) {
        console.log("company : ", this.company);
        console.log("fetchTablesData params", {
            companyId: this.company?.id,
            className,
            budgetId,
            periods,
            tags,
            operatingAccountId,
            accountingPeriodId,
        });
        const response = await this.apolloClient.query({
            query: ACCOUNTING_TABLE,
            variables: {
                companyId: this.company?.id,
                className,
                budgetId,
                periods,
                tags,
                operatingAccountId,
                accountingPeriodId,
            },
            fetchPolicy: "network-only",
        });

        const output: any = response.data.accountingTable?.output
            ? JSON.parse(JSON.stringify(response.data.accountingTable?.output))
            : null;
        let dashboardTable: DashBoardTableStream;
        if (response.data.accountingTable) {
            console.log("isExtensible output : ", Object.isExtensible(output));
            for (const table of output.tables) {
                // const table = Object.assign({expanded: []}, table_)
                console.log("isExtensible table : ", Object.isExtensible(table));
                console.log("table : ", table);
                // table.expanded = []
                this.setColumnsToDisplay(output, table, output.periods);
            }
            this.computeTableHeaders(output.tables, output.periods);
            const customAmounts = output.customAmounts;
            dashboardTable = new DashBoardTableStream(
                this.apolloClient,
                output.periods,
                output.tables,
                accountingPeriodId,
                customAmounts,
            );
            // this.updateAmounts()
        }
        if (returnDashboardTable) {
            return [output?.tables, dashboardTable];
        }
        return output?.tables;
    }

    async fetchAccountingResultsTableData(
        { className, budgetId, periods, tags, operatingAccountId, accountingPeriodId },
        returnDashboardTable = false,
    ) {
        const [tables, dashboardTable] = await this.fetchTablesData(
            { className, budgetId, periods, tags, operatingAccountId, accountingPeriodId },
            true,
        );

        // const tabledata = tables ? tables.find(t => t.name === "Compte de résultat") : null
        const tabledata = tables?.[0];

        console.log("fetchAccountingResultsTableData", tabledata);

        if (returnDashboardTable) {
            return [tabledata, dashboardTable];
        }
        return tabledata;
    }

    setColumnsToDisplay(output, table, periods) {
        const columnsToDisplay = [];
        for (const pi in periods) {
            columnsToDisplay.push([]);
            // let found = false
            for (const ci in table.columns) {
                if (
                    output.tables.length === 1 ||
                    pi === "0" ||
                    table.columns[ci].key === "netAmounts"
                ) {
                    columnsToDisplay[pi].push(table.columns[ci]);
                }
            }
        }
        table.columnsToDisplay = columnsToDisplay;
    }

    computeTableHeaders(tables, resultPeriods) {
        for (const table of tables) {
            const firstHeaders: any = [{ text: "", value: "", align: "left", width: "40%" }];
            const headers: any = [
                { text: "Postes", value: "name", align: "left", sortable: false, width: "40%" },
            ];
            let pi = 0;
            for (const period of resultPeriods) {
                let columnCount = 0;
                for (const col of table.columns) {
                    if (table.name !== "Actif" || pi === 0 || col.key === "netAmounts") {
                        // pour ne pas afficher brut et net des années précédentes dans le Bilan
                        let text = "";
                        if (period.name) {
                            text = period.name;
                        }
                        if (col.name) {
                            if (text) text += " ";
                            text += col.name;
                        }
                        // if (!period.name) {
                        //     if (text) text += " "
                        //     text += this.periodHeader(period)
                        //     // text += pi
                        // }
                        headers.push({
                            text,
                            value: "",
                            align: "right",
                            sortable: false,
                        });
                        columnCount++;
                    }
                }

                if (table.relativePercentage) {
                    headers.push({
                        text: "%",
                        value: "",
                        align: "right",
                        sortable: false,
                    });
                    columnCount++;
                }
                firstHeaders.push({
                    text: this.periodHeader(period),
                    value: "",
                    align: "center",
                    sortable: false,
                    colspan: columnCount,
                });
                pi++;
            }
            if (table.comparison) {
                if (table.comparison.difference) {
                    headers.push({
                        text: "Différence",
                        value: "difference",
                        align: "right",
                        sortable: false,
                    });
                    firstHeaders.push({ text: "", value: "", align: "left" });
                }
                if (table.comparison.percentage) {
                    headers.push({
                        text: "%",
                        value: "percentage",
                        align: "right",
                        sortable: false,
                    });
                    firstHeaders.push({ text: "", value: "", align: "left" });
                }
            }
            if (table.extraColumns) {
                for (const column of table.extraColumns) {
                    headers.push({
                        text: column.displayName,
                        value: "",
                        align: "right",
                        sortable: false,
                    });
                }
                firstHeaders.push({ text: "", value: "", align: "right" });
            }
            table.headers = [];
            table.headers.push(firstHeaders);
            table.headers.push(headers);
        }
    }

    periodHeader(period) {
        if (period.start && period.end) {
            return moment(period.start)
                .utc(false)
                .format("MM[/]YYYY")
                .concat(" - ", moment(period.end).utc(false).format("MM[/]YYYY"));
        } else {
            debugger; // git-ignore
        }
        return "XXX";
    }

    // @Apollo({
    //     query() {
    //         return GET_AMOUNT_IN_GENERAL_DICO
    //     },
    //     variables() {
    //         return {
    //             companyId: this.companyId,
    //             periods: this.periods,
    //             key: this.key1,
    //             key2: this.key2
    //         }
    //     },
    //     skip() {
    //         return !this.periods.length
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         this.loading = loading
    //         if (!loading && data) {
    //             if (data.getAmountInGeneralDico) {
    //                 this.output = data.getAmountInGeneralDico.output
    //             }
    //         }
    //         console.log("output", this.output)
    //     }
    // })
    // output: any = {}

    async fetchRatioData({ periods, numeratorKey, denominatorKey }) {
        if (!periods.length) return null;
        const response = await this.apolloClient.query({
            query: GET_AMOUNT_IN_GENERAL_DICO,
            variables: {
                companyId: this.company?.id,
                periods,
                key: numeratorKey,
                key2: denominatorKey,
            },
            fetchPolicy: "network-only",
        });

        console.log("response : ", response, "params", { periods, numeratorKey, denominatorKey });

        return response.data.getAmountInGeneralDico?.output?.tables?.[0];
    }

    // @Apollo({
    //     query() {
    //         return this.getQuery()
    //     },
    //     variables() {
    //         return {
    //             companyId: this.companyId,
    //             className: this.className,
    //             budgetId: this.budgetId,
    //             periods: this.periods,
    //             tags: this.myKey !== 'Bilan' ? this.tags || undefined : undefined,
    //             operatingAccountId: this.operatingAccountId_,
    //             accountingPeriodId: this.accountingPeriodId
    //         }
    //     },
    //     fetchPolicy: 'network-only',
    //     skip() {
    //         return !this.companyId || !this.className || (!this.periods.length && !this.budgetId) || !this.getQuery() || this.skipApollo || !this.accountingPeriodId || (this.className==="OperatingAccountCustom" && !this.operatingAccountId_)
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         console.log("data : ", data)
    //         this.loading = loading
    //         if (!loading && data) {
    //             if (data[this.resultKey]) {
    //                 const output = data[this.resultKey].output
    //                 for (const table of output.tables) {
    //                     table.expanded = []
    //                     this.setColumnsToDisplay(output, table, output.periods)
    //                 }
    //                 this.output = output
    //                 this.tables = this.output.tables
    //                 this.resultPeriods = this.output.periods
    //                 this.computeTableHeaders()
    //                 const customAmounts = this.output.customAmounts
    //                 this.dashboardTable = new DashBoardTableStream(this.$apollo, this.resultPeriods, this.tables, this.accountingPeriodId, customAmounts)
    //                 this.updateAmounts()
    //                 this.$emit("table", this.tables)
    //             }
    //             console.log("output", this.output)
    //         }
    //     }
    // })
    // output = {
    //     resultPeriods: [],
    //     tables: []
    // }

    /**
     * Operating accounts data
     * @param use
     * @returns
     */
    async fetchOperatingAccountJsons(
        use: string = "OPERATING_ACCOUNT",
    ): Promise<OperatingAccountDataInterface[]> {
        const response = await this.apolloClient.query({
            query: OPERATING_ACCOUNT_QUERY,
            variables: { companyId: this.company?.id, use },
            fetchPolicy: "network-only",
        });

        return response.data.scopingOperatingAccount.data || [];
    }

    // @Apollo({
    //     query() {
    //         return OPERATING_ACCOUNT_QUERY;
    //     },
    //     variables() {
    //         return {
    //             companyId: this.companyId,
    //             use: "OPERATING_ACCOUNT"
    //         };
    //     },
    //     skip() {
    //         return !this.isAuthorized || !this.companyId
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading && data && data.scopingOperatingAccount) {
    //             this.operatingAccountJsons = data.scopingOperatingAccount.data || []
    //         } else {
    //             this.operatingAccountJsons = []
    //         }
    //         this.apolloFinished = true
    //     }
    // })
    // operatingAccountJsons = [];
}
